<template>
	<div class="container mt-3">
		<template v-if="data.hasOwnProperty('customView') && data.customView === 'true'">
			<template v-for="item in this.convertedHtmlArray(this.data.body, this.data.modules.forms, this.data.modules.documents)">
				<template v-if="item.hasOwnProperty('type')">
					<inline-document v-if="item.type === InlineModuleTypeEnum.DOCUMENT" :item="item.items"/>
					<inline-form v-if="item.type === InlineModuleTypeEnum.FORM" :item="item.items"/>
				</template>
				<component v-else :is="{template: item}" />
			</template>
		</template>
		<template v-else>
			<v-card :header="showTitle ? title : ''">
				<template v-for="item in this.convertedHtmlArray(this.data.body, this.data.modules.forms, this.data.modules.documents)">
					<template v-if="item.hasOwnProperty('type')">
						<inline-document v-if="item.type === InlineModuleTypeEnum.DOCUMENT" :item="item.items"/>
						<inline-form v-if="item.type === InlineModuleTypeEnum.FORM" :item="item.items"/>
					</template>
					<span v-else v-html="item"></span>
				</template>
			</v-card>
		</template>
	</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import VCard from "../../../Components/VCard.vue";
import {SimpleTextComponentInterface} from "../Interfaces/Components/SimpleTextComponentInterface";
import InlineForm from "../../../Components/InlineForm.vue";
import InlineDocument from "../../../Components/InlineDocument.vue";
import {InlineModuleTypeEnum} from "../Enums/InlineModuleTypeEnum";
import {InlineModuleMixin} from "../../../Mixins/InlineModuleMixin";

export default defineComponent({
	name: "SimpleTextComponent",
	mixins: [InlineModuleMixin],
	components: {InlineDocument, InlineForm, VCard},
	computed: {
		InlineModuleTypeEnum() {
			return InlineModuleTypeEnum
		}
	},
	props: {
		title: {
			type: String,
			required: false,
		},
		data: {
			type: Object as PropType<SimpleTextComponentInterface>,
			default: [],
			required: true
		},
		showTitle: {
			type: Boolean,
			default: true,
			required: false
		}
	},
});
</script>

<style scoped>
:deep(table), :deep(td), :deep(tr) {
	border: 1px solid;
}
:deep(ul) {
	list-style: initial;
	padding-left: 20px;
}
:deep(ol) {
	list-style: decimal;
	padding-left: 20px;
}
</style>
